import superagent from 'superagent'
import { encrypt } from '@/utils/des'
import { host, tokenPrefix } from './host'

const registUser = ({ user_name, password, shop_id }) => {
    return new Promise((resolve, reject) => {
        superagent.post(`${host}/v1/user/create`)
        .set('token', encrypt(`${tokenPrefix}.user`))
        .send({
            user_name,
            password,
            shop_id,
            create_time: Date.now() + '',
            whitelist: '[]',
        })
        .then((res) => {
            if (res.body.err === 0) {
                resolve(res.body.data.user_id)
            } else {
                reject(res.body.msg)
            }
        }, (err) => {
            reject(err)
        })
    })
}

const getUserList = () => {
    return new Promise((resolve, reject) => {
        superagent.post(`${host}/v1/user/list/1/1000`)
            .set('token', encrypt(`${tokenPrefix}.user`))
            .send({})
            .then((res) => {
                if (res.body.err === 0) {
                    resolve(res.body.data)
                }
            }, (err) => {
                reject(err)
            })
    })
}

const updateUserInfo = (user_id, { user_name, password, shop_id, whitelist, create_time }) => {
    return new Promise((resolve, reject) => {
        const date = new Date(create_time)
        create_time = `${date.getTime()}`
        superagent.put(`${host}/v1/user/${user_id}/update`)
            .set('token', encrypt(`${user_id}.user`))
            .send({
                user_name,
                password,
                shop_id,
                whitelist: JSON.stringify(whitelist),
                user_id,
                create_time,
            })
            .then((res) => {
                if (res.body.err === 0) {
                    resolve(res.body.data)
                }
            }, (err) => {
                reject(err)
            })
    })
}

const deleteUser = (user_id) => {
    return new Promise((resolve, reject) => {
        superagent.put(`${host}/v1/user/${user_id}/delete`)
            .set('token', encrypt(`${user_id}.user`))
            .send({
                user_id,
            })
            .then((res) => {
                if (res.body.err === 0) {
                    resolve(res.body.data)
                }
            }, (err) => {
                reject(err)
            })
    })
}

export {
    registUser,
    getUserList,
    deleteUser,
    updateUserInfo,
}
